import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { ThemeContext } from "../App";
import { LogOut, Settings, KeyRound, Moon, Sun, ArrowLeft, CircleUserRound } from "lucide-react";


export default function Navbar() {
  const { user, logoutUser } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown = useCallback(() => setDropdownOpen((prev) => !prev), []);
  const settings = useCallback(() => navigate("/settings"), [navigate]);
  const trocarSenha = useCallback(() => navigate("/chanpasswd"), [navigate]);
  const goBack = useCallback(() => navigate(-1), [navigate]);
  const goHome = useCallback(() => navigate("/dashboard"), [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  if (!user) return null;

  const showBackButton = location.pathname !== "/dashboard";

  return (
    <nav className="navbar">
      <span className="navbar-brand" onClick={goHome} style={{ cursor: "pointer" }}>BES</span>

      <div className="navbar-actions">
        {showBackButton && (
          <button className="btn-back" onClick={goBack}>
            <ArrowLeft size={18} />
            Voltar
          </button>
        )}

        <div className="dropdown" ref={dropdownRef}>
          <button
            className={`dropdown-toggle ${isDropdownOpen ? "active" : ""}`}
            onClick={toggleDropdown}
            title="Menu do usuário"
          >
            <CircleUserRound size={18} /> {user?.nome || "Usuário"}
            <span className="caret" />
          </button>

          <div className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
            <button className="dropdown-item" onClick={() => {setDropdownOpen(false); settings();}}>
              <Settings size={18} /> Configurações
            </button>

            <button className="dropdown-item" onClick={() => {setDropdownOpen(false); trocarSenha();}}>
              <KeyRound size={18} /> Trocar Senha
            </button>

            <button className="dropdown-item" onClick={toggleTheme}>
              {theme === "light" ? (
                <>
                  <Moon size={18} /> Modo Escuro
                </>
              ) : (
                <>
                  <Sun size={18} /> Modo Claro
                </>
              )}
            </button>

            <button className="dropdown-item logout" onClick={logoutUser}>
              <LogOut size={18} /> Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
